import React from "react";

export const VnRecaptcha = () => {
  return <div id="recaptcha-container" />;
};
